const routes = {
  about: "/",
  skill: "/skills",
  games: "/games",
  projects: "/projects",
  partner: "/partner",
  pinterest: "/pinterest",
  projectDetails: "/projects/:projectName",

  nuoitoi: "/nuoitoi",
  notfound: "/*",
};

export default routes;

